<template>
  <v-navigation-drawer :value="value" @input="$emit('input', $event)" app>
    <v-layout fill-height column>
      <v-toolbar
        flat
        color="primary"
        :class="{
          saPrimary: layout == DEFINES.LAYOUT_ADMIN,
        }"
      >
        <!-- <v-card
          color="primary"
          :class="{
            saPrimary: layout == DEFINES.LAYOUT_ADMIN,
          }"
          width="100%"
          height="45px"
          flat
        >
          <v-img
            contain
            height="100%"
            src="../assets/logo_white.png"
          ></v-img>
        </v-card> -->
      </v-toolbar>

      <div>
        <v-layout row wrap justify-center align-center>
          <v-flex xs12 class="px-1 py-1 text-xs-center">
            <v-layout row wrap justify-center align-center>
              <template v-if="company && layout == DEFINES.LAYOUT_APP">
                <!-- Avatar -->
                <div>
                  <v-card
                    :to="{name: 'CompanyPayment', params: {company_id: company.id}}"
                    v-if="company.logo_url"
                    height="10vmin"
                    width="250"
                    flat
                  >
                    <v-img
                      height="100%"
                      contain
                      :src="company.logo_url"
                    ></v-img>
                  </v-card>
                  <div v-else>
                    <v-card :to="{name: 'CompanyProfile', params: {company_id: company.id}}" flat class="transparent">
                      <avatar  :size="80" :username="company.title"></avatar>
                    </v-card>
                  </div>
                </div>
                <!-- User Info -->
                <v-flex xs12>
                  <div class="py-1">
                    <div class="title grey--text text--darken-3">
                      <v-tooltip
                        v-if="company.is_screening_pricing_enterprise"
                        slot="append"
                        top
                        color="white"
                      >
                        <v-icon slot="activator" color="blue" size="20"
                          >$vuetify.icons.enterprise</v-icon
                        >
                        <span class="greyDarken3--text body-1">
                          {{ $t("enterprise.tooltip") }}
                        </span></v-tooltip
                      >
                      {{ company.title }}
                    </div>
                    <a :href="company.domain" target="_blank" rel="noopener noreferrer">{{company.domain}}</a>
                    <!-- <div class="pt-1 grey--text text--darken-2">
                      <span>{{ user.email }}</span>
                      <span>&nbsp;•&nbsp;</span>
                      <span
                        ><b>{{ DEFINES.ROLE_STR[company.pivot.role] }}</b></span
                      >
                    </div> -->
                    <v-tooltip bottom v-if="timezone" color="white">
                      <template v-slot:activator="{ on }">
                        <div class="body-2 py-1" v-on="on">
                          {{ timezone }} {{ "UTC" + momentTz.tz(timezone).format("Z") }}
                        </div>
                      </template>
                      <span class="body-1 grey--text text--darken-3">
                        <b>Company Timezone.</b>
                        <br />All time inputs you provide will be according to company
                        configured timezone. <br />You can change it in your company setting.
                      </span>
                    </v-tooltip>
                    <v-divider></v-divider>
                    <div class="pt-1 grey--text text--darken-2">
                       <v-tooltip bottom color="white">
                        <template v-slot:activator="{ on }">
                          <span class="body-2 pt-1" v-on="on">
                            <v-btn rounded="0" small @click="$emit('showCompanySwitcher')" icon><v-icon >mdi-account-switch</v-icon></v-btn>
                          </span>
                        </template>
                        <span class="body-1 grey--text text--darken-3">
                          {{$t('company.tooltip.description.switch_organization')}}
                        </span>
                      </v-tooltip>
                      <!-- <v-tooltip bottom color="white">
                        <template v-slot:activator="{ on }">
                          <span class="body-2 pt-1" v-on="on">
                            <v-btn rounded="0" small :to="{name: 'CompanyPayment', params: {company_id: company.id}}" icon><v-icon small>mdi-credit-card-multiple</v-icon></v-btn>
                          </span>
                        </template>
                        <span class="body-1 grey--text text--darken-3">
                          {{$t('company.tooltip.description.payment')}}
                        </span>
                      </v-tooltip>
                      <v-tooltip bottom color="white">
                        <template v-slot:activator="{ on }">
                          <span class="body-2 pt-1" v-on="on">
                            <v-btn rounded="0" small :to="{name: 'CompanyTheme', params: {company_id: company.id}}" icon><v-icon small>mdi-invert-colors</v-icon></v-btn>
                          </span>
                        </template>
                        <span class="body-1 grey--text text--darken-3">
                          {{$t('company.tooltip.description.theme')}}
                        </span>
                      </v-tooltip> -->
                      <v-tooltip bottom color="white">
                        <template v-slot:activator="{ on }">
                          <span class="body-2 pt-1" v-on="on">
                            <v-btn rounded="0" small :to="{name: 'CompanySetting', params: {company_id: company.id}}" icon><v-icon>$vuetify.icons.rms_setting</v-icon></v-btn>
                          </span>
                        </template>
                        <span class="body-1 grey--text text--darken-3">
                          {{$t('company.tooltip.description.setting')}}
                        </span>
                      </v-tooltip>
                    </div>
                  </div>
                </v-flex>
              </template>
              <template v-if="layout == DEFINES.LAYOUT_ADMIN">
                <div class="mb-2">
                  <avatar :size="120" :username="user.email"></avatar>
                </div>
                <!-- User Info -->
                <v-flex xs12>
                  <!-- <div>
                    <div
                      v-if="user.name"
                      class="title grey--text text--darken-3 mb-1"
                    >
                      {{ user.name }}
                    </div>
                    <div class="grey--text text--darken-2 mb-1">
                      <span>{{ user.email }}</span>
                      <span>&nbsp;•&nbsp;</span>
                      <span
                        ><b>{{ DEFINES.USER_ROLE_STR[user.role] }}</b></span
                      >
                    </div>
                  </div> -->
                  <div class="title grey--text text--darken-1">
                    <v-tooltip bottom v-if="timezone" color="white">
                    <template v-slot:activator="{ on }">
                      <div class="body-1 pt-1" v-on="on">
                        {{ timezone }} {{ "UTC" + momentTz.tz(timezone).format("Z") }}
                      </div>
                    </template>
                    <span class="body-1 grey--text text--darken-1">
                      <b>Company Timezone.</b>
                      <br />All time inputs you provide will be according to company
                      configured timezone. <br />You can change it in your company setting.
                    </span>
                  </v-tooltip>
                  </div>
                </v-flex></template
              >
              <!-- App Version -->
              <!-- <v-flex xs12>
                <small class="grey--text text--darken-2"
                  >App Version&nbsp;:&nbsp;<b>{{
                    DEFINES.APP_VERSION
                  }}</b></small
                >
              </v-flex> -->
            </v-layout>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
      </div>
      <!-- Changable menue as per admin or app layout -->
      <v-layout column style="height: 20vh; overflow: auto">
        <!-- Super Admin Menu -->
        <ListMenu
          :menus="admin_menu"
          :subheader="$t('company.title')"
        ></ListMenu>
        <!-- Company Menu -->
        <ListMenu
          :menus="common_menu"
        ></ListMenu>
        <ListMenu
          :menus="company_menu"
          :subheader="$t('company.title')"
          is_add_on="true"
        ></ListMenu>
        <!-- <ListMenu
          :menus="account_menu"
          subheader="Account"
          is_logout="true"
          is_add_on="true"
        ></ListMenu> -->
      </v-layout>

      <div class="text-xs-center">
        <ConfirmationDialog
          v-if="environment == 'TEST' && layout == DEFINES.LAYOUT_ADMIN"
          desc="admin.drawer.button.pull_latest_changes.confirmation.desc"
          :action="
            getDialogAction(
              null,
              'rms_delete',
              'error',
              'admin.drawer.button.pull_latest_changes'
            )
          "
          headline="admin.drawer.button.pull_latest_changes.confirmation.heading"
          :button_type="'button'"
        ></ConfirmationDialog>
      </div>
      <!-- Same Menus For User and Admin -->
      <v-divider></v-divider>
      <!-- Hide temporary for the screener app -->
      <admin-switcher v-if="layout == DEFINES.LAYOUT_ADMIN"></admin-switcher>
      <v-list v-if="session_mode == DEFINES.SESSION_MODE_SUPER_ADMIN">
        <template>
          <v-list-tile
            color="default-class highlight"
            @click="leaveImpersonation()"
          >
            <v-list-tile-action>
              <v-icon color="warning"
                >$vuetify.icons.rms_leave_impersonation</v-icon
              >
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title color="success">{{
                $t("rms.drawer_leave_impersonation")
              }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-layout>
  </v-navigation-drawer>
</template>

<script>
import ListMenu from "@/components/ListMenu";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import Avatar from "vue-avatar";
import { mapGetters, mapState } from "vuex";
import Logout from "@/components/Logout";
import * as MENU from "@/menu";
import AdminSwitcher from "@/components/AdminSwitcher";

export default {
  name: "Drawer",
  props: [
    "value",
    "company_menu",
    "account_menu",
    "screener_menu",
    "admin_menu",
    "common_menu"
  ],
  components: {
    ListMenu,
    Logout,
    Avatar,
    ConfirmationDialog,
    AdminSwitcher,
  },
  data() {
    return {
      environment: process.env.VUE_APP_BUILD_MODE,
    };
  },

  computed: {
    ...mapGetters({
      selectedCompanyId: "company/getSelected",
      session_mode: "auth/getSessionMode",
      company: "company/getSelectedCompany",
      timezone: "company/getSelectedCompanyTimezone",
    }),
    ...mapState({
      layout: (state) => state.app.app.layout,
      key: (state) => state.auth.key,
      user: (state) => state.user.profile,
    }),
  },
  methods: {
    async deploy() {
      await this.$store.dispatch("adminDashboard/deployStage");
      this.$store.dispatch("app/showMessage", {
        message: "Request initiated successfully !",
        color: "success",
      });
    },

    leaveImpersonation: function () {
      this.$store.dispatch("impersonation/leave", {
        key: this.key,
      });
    },
    getDialogAction(update_status, btn_icon, btn_color, btn_label) {
      return {
        button_icon: btn_icon,
        button_color: btn_color,
        method: this.deploy,
        payload: update_status,
        button_label: btn_label,
      };
    },
    viewWebsite(){
      if(this.company.domai){
        return;
      }
      window.open(this.company.domain, '_blank');
    }
  },
};
</script>
